import { Navigate, useParams } from "react-router-dom"
import { usePublicSiteId } from "../contexts/PublicSiteContext"
import { isConstructionWalk } from "../utils/publicSite"

/** Storage/Patrol location tools (create walks, reports, edit) are not Sage job sites. */
export default function StorageLocationRoutes({ children }: { children: JSX.Element }) {
  const siteId = usePublicSiteId()
  const { id } = useParams()

  if (isConstructionWalk(siteId)) {
    return <Navigate to={id ? `/app/locations/${id}` : "/app/locations"} replace />
  }

  return children
}
